import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output
} from '@angular/core';
import {MenuChange} from '@emm/core/models/menu-change.model';
import {AuthFacadeService} from '@emm/auth/services/auth-facade.service';
import {FeatureScope} from '@emm/core/util/feature-scope.constants';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'emm-change',
    styleUrls: ['./change.component.scss'],
    templateUrl: './change.component.html',
    standalone: false
})
export class ChangeComponent implements OnInit {

    isReadOnly$ = this.authFacade.isReadOnly$; // read-only user
    isReadOnlyScope: boolean; // read-only feature scope - consider merge with isReadOnly$

    @Input() change: MenuChange;
    @Input() lastChange;
    @Input() featureScope: string;

    @Output() changeDeleted = new EventEmitter();

    constructor(private authFacade: AuthFacadeService) {}

    ngOnInit(): void {
        this.isReadOnlyScope = this.featureScope === FeatureScope.Client ||
            this.featureScope === FeatureScope.Viewer;
    }

    deleteChange(changeId): void {
        this.changeDeleted.emit(changeId);
    }

}
